import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useCreateRfiOrganizationMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  RFIOrganization,
  useOrganizationsTableContext,
} from '../../../../OrganizationsTableContext'
import { CreateOrganizationModalBody } from './components/CreateOrganizationModalBody'
import { useProjectContext } from 'context/ProjectContext'

export function useCreateOptions(): CreateHeaderActionOptions<RFIOrganization> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useOrganizationsTableContext()
  const [createRfiOrganization] = useCreateRfiOrganizationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createRFIOrganization: {
        organization: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Organization',
    permission: Permission.CreateRFIOrganization,
    modal: {
      type: 'simple',
      body: <CreateOrganizationModalBody />,
      onOk: async ({ name, description }) => {
        await createRfiOrganization({
          variables: {
            createRfiOrganizationInput: { projectId, name, description },
          },
        })
        await refetch()
      },
    },
  }
}
